import { makeStyles, Theme } from '@material-ui/core';

const useStyles = makeStyles<Theme>((theme: Theme) => ({
  root: {
    display: 'flex',
    alignItems: 'center',
  },
  label: {
    marginRight: theme.spacing(0.5),
    width: '160px',
  },
  notFoundValue: {
    color: theme.palette.error.dark,
  },
}));

export default useStyles;
